import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  DialogContent,
  DialogTitle,
  Divider,
  Grid,
  styled,
  Typography,
} from '@mui/material';
import { DynamicTooltipChip } from 'src/components/dynamicTooltipChip/DynamicTooltipChip';

export const StyledLabelValue = styled(Typography)(
  () => `
    font-size: 16px;
    line-height: 18px,
    font-weight: 300;
    `,
);

export const StyledProductImage = styled('img')(
  ({ theme }) => ` 
    width: 200px;
    height: auto;
    background-size: contain;
    background-position: bottom;
    background-repeat: no-repeat;
    border: 1px solid ${theme.palette.secondary.light};
    border-radius: 7px;
    `,
);

export const ScrollableContainer = styled('div')`
  overflow-y: auto;
  height: calc(100vh - 339px);
`;

export const StyledGrid = styled(Grid)`
  margin-top: 10px;
  margin-bottom: 20px;
`;

export const NoLeftSpacedItem = styled(Grid)`
  &.MuiGrid-item {
    padding-left: 0;
  }
`;

export const StyledDivider = styled(Divider)(
  ({ theme }) => `
    border-color: ${theme.palette.brand.disable};
  `,
);

export const StyledAccordion = styled(Accordion)(
  ({ theme }) => `
   margin-bottom: 0;
   border-bottom: 1px solid ${theme.palette.brand.disable};
    &.Mui-expanded {
            &:last-of-type{
                margin-bottom: 20px;
            }
            & .MuiButtonBase-root {
                min-height: auto;
            }
        }
        `,
);

export const StyledAccordionDetails = styled(AccordionDetails)`
  padding-bottom: 20px;
`;

export const StyledAccordionItemWrapper = styled(AccordionSummary)`
  padding: 0;
  margin-bottom: 0;
  justify-content: start;

  & .MuiAccordionSummary-content {
    margin: 0;
  }

  & div {
    overflow: hidden;
  }
`;
export const ProductNameText = styled(Typography)<{ $width: number }>`
  max-width: ${({ $width }: { $width: number }) =>
    $width ? `${$width}vw` : ''};
`;

export const ProductSizeText = styled(Typography)`
  white-space: pre-wrap;
  font-size: 24px;
  font-weight: 400;
`;

export const StyledDialogContent = styled(DialogContent)(() => ({
  display: 'flex',
  flexDirection: 'column',
  gap: '36px',
}));

export const StyledDialogTitle = styled(DialogTitle)`
  padding: 0;
  margin: 16px 24px;
`;

export const StyledChipContainer = styled(Box)`
  margin: 0 5px 5px 0;
  display: inline-block;
`;

export const StyledDynamicTooltipChip = styled(DynamicTooltipChip)`
  max-width: 272px;
`;
